import { MuiPage } from "../../../components";
import FeaturesAccessEdit from "./featureAccess.edit";

export const FeatureAccessAddEdit = (props: any) => {

    return (
        <MuiPage>
            <FeaturesAccessEdit />
        </MuiPage>
    );
}